import type { GetUserThreads200ItemCurrentUserStatus } from './getUserThreads200ItemCurrentUserStatus';
import type { GetUserThreads200ItemParticipantsItem } from './getUserThreads200ItemParticipantsItem';

export type GetUserThreads200Item = {
  chatRoomId: number;
  createdAt: string;
  currentUserStatus?: GetUserThreads200ItemCurrentUserStatus;
  isGroupThread: boolean;
  /** @nullable */
  lastMessage?: string | null;
  /** @nullable */
  lastMessageTime?: string | null;
  participants: GetUserThreads200ItemParticipantsItem[];
  /** @nullable */
  unreadMessageCount?: number | null;
};
